import { Email, LocationOn, Phone } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';
import IconWrapper from 'lib/designSystem/IconWrapper';
import React from 'react';
import { useSelector } from 'react-redux';
import { ClientConfigState } from 'services/redux/clientConfigSlice';

const Footer = () => {
  const expressConfig = useSelector(
    (state: { clientConfiguration: ClientConfigState }) =>
      state.clientConfiguration.configs,
  );

  const email = expressConfig?.pruffConnect_footer_email;
  const phone = expressConfig?.pruffConnect_footer_phone;
  const address = expressConfig?.pruffConnect_footer_address;
  return (
    email &&
    phone &&
    address && (
      <Box
        component="footer"
        sx={{
          padding: '32px 20px 16px',
          borderTop: '1px solid #eaecf0',
          backgroundColor: '#F8FAFC',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 3,
        }}
      >
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={10}
          sx={{
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
          }}
        >
          {address && (
            <Stack
              direction="row"
              spacing={1.5}
              alignItems="center"
              component="a"
              href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                justifyContent: 'center',
                textDecoration: 'none',
                cursor: 'pointer',
                '&:hover': {
                  opacity: 0.8,
                },
              }}
            >
              <IconWrapper color="secondary">
                <LocationOn fontSize="medium" />
              </IconWrapper>
              <Typography
                variant="body2"
                sx={{ color: '#475467', fontWeight: 400 }}
              >
                {address}
              </Typography>
            </Stack>
          )}
          {phone && (
            <Stack
              direction="row"
              spacing={1.5}
              alignItems="center"
              component="a"
              href={`tel:${phone.replace(/\s/g, '')}`}
              sx={{
                justifyContent: 'center',
                textDecoration: 'none',
                cursor: 'pointer',
                '&:hover': {
                  opacity: 0.8,
                },
              }}
            >
              <IconWrapper color="secondary">
                <Phone fontSize="medium" />
              </IconWrapper>
              <Typography
                variant="body2"
                sx={{ color: '#475467', fontWeight: 400 }}
              >
                {phone}
              </Typography>
            </Stack>
          )}
          {email && (
            <Stack
              direction="row"
              spacing={1.5}
              alignItems="center"
              component="a"
              href={`mailto:${email}`}
              sx={{
                justifyContent: 'center',
                textDecoration: 'none',
                cursor: 'pointer',
                '&:hover': {
                  opacity: 0.8,
                },
              }}
            >
              <IconWrapper color="secondary">
                <Email fontSize="medium" />
              </IconWrapper>
              <Typography
                variant="body2"
                sx={{ color: '#475467', fontWeight: 400 }}
              >
                {email}
              </Typography>
            </Stack>
          )}
        </Stack>
        <Typography
          variant="caption"
          sx={{
            color: '#98A2B3',
            fontSize: '11px',
            fontWeight: 400,
            textAlign: 'center',
            mt: 1,
          }}
        >
          Powered by Pruff
        </Typography>
      </Box>
    )
  );
};

export default Footer;
